import { MappedAnswer } from '../components/context/SurveyPageContext';

interface CurrentPageAnswersProps {
  mappedAnswers: Map<number, MappedAnswer>;
  currentPageQuestionIds: number[];
}

const pageAnswers = ({
  mappedAnswers,
  currentPageQuestionIds,
}: CurrentPageAnswersProps): MappedAnswer[] =>
  Array.from(mappedAnswers.values()).filter(
    (answer) => answer.question.id && currentPageQuestionIds.includes(answer.question.id),
  );

export { pageAnswers };
